import myAxios from './myAxios';
import { apiActions, signinActions } from './index';

export const fetchCurrentEpisode = (episodeId) => (
  (dispatch) => {
    return myAxios.get(routes().get_episode + episodeId)
      .then((response) => {
        dispatch(fetchCurrentEpisodeSuccess(response.data));
        return response.data;
      })
      .catch((err) => {
        dispatch(fetchCurrentEpisodeSuccess(err));
      })
  }
);

export const unlockEpisode = episodeId => (
  (dispatch) => {
    dispatch({ type: "PROCESSING_ON" })
    return myAxios.post(routes().get_episode + episodeId + '/unlock')
      .then((response) => {
        return dispatch(apiActions.fetchInitialData());
      })
      .then((data) => {
        dispatch({ type: "PROCESSING_OFF" })
      })
      .catch((err) => {
        console.error(err);
        dispatch({ type: "PROCESSING_OFF" })
      });
  }
);

export const fetchCurrentEpisodeSuccess = (payload) => ({type: 'FETCH_CURRENT_EPISODE_SUCCESS', payload });

export const poppinAdd = (pageIdx, poppin) => ({type: 'POPPIN_ADD', pageIdx, poppin});
export const poppinDelete = poppin => ({ type: 'POPPIN_DELETE', poppin });
export const poppinDraggedSet = (pinIdx, pageIdx, posX, posY) => (
  {type: 'POPPIN_DRAGGED_SET', pinIdx, pageIdx, posX, posY }
);

export const poppinBodySet = poppin => ({
  type: 'POPPIN_BODY_SET',
  poppin
});

export const toggleLikedEpisode = () => ({ type: 'TOGGLE_LIKE_EPISODE' });

export const episodeToggleLike = episodeId => (
  (dispatch) => {
    myAxios.post(routes().get_episode + episodeId + '/like')
      .then(() => dispatch(toggleLikedEpisode()))
      .catch((err) => {
        console.error(err);
      });
  }
);

export const updatePopCommentsCounter = payload => ({
  type: 'UPDATE_POPCOMMENTS_COUNTER',
  payload
});

export const setCommentsCount = (comments_count) => {
  return {
    type: 'SET_COMMENTS_COUNT',
    comments_count
  }
};
